import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { api } from '../services/api/client';

export const ProtectedRoute: React.FC = () => {
  const token = api.getToken();
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return <Outlet />;
};
